import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import Counter from '../components/counter'
import Cta from '../components/cta'
import Team from '../components/team'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import AboutOne from '../components/about-one'

import hero from '../assets/images/hero/pages.jpg'

export default function Aboutus() {
  return (
    <>
    <Navbar/>

    <section className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${hero})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-gradient-overlay"></div>
        <div className="container">
            <div className="row mt-5 justify-content-center">
                <div className="col-12">
                    <div className="title-heading text-center">
                        <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">About Us</h5>
                    </div>
                </div>
            </div>

            <div className="position-middle-bottom">
                <nav aria-label="breadcrumb" className="d-block">
                    <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                        <li className="breadcrumb-item"><Link to="/">Supercoin</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">About us</li>
                    </ul>
                </nav>
            </div>
        </div>
    </section>

    <div className="position-relative">
        <div className="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>

    <section className="section">
        <div className="container">
            <AboutOne/>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row align-items-center">
                <div className="col-lg-7 col-md-6">
                    <div className="section-title">
                        <h6 className="text-primary text-uppercase">What we achieved?</h6>
                        <h4 className="title mb-3">Beyond Conventional <br/> Agencies.</h4>
                        <p className="text-muted para-desc mb-0">As a leading college in Auckland, we look to engage with our student beyond the conventional design and development school relationship, becoming a partner to the people and companies we work with.</p>
                    </div>
                </div>

                <div className="col-lg-5 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                    <div className="position-relative">
                        <Counter/>
                        <div className="position-absolute top-50 start-50 translate-middle z-n1">
                            <div className="bg-primary rounded opacity-75 p-5"><div className="p-5"></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Cta/>

    <section className="section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Our Minds</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>
                    </div>
                </div>
            </div>
            <Team/>
        </div>
    </section>

    <Footer/>

    <ScrollToTop/>
    </>
  )
}
